<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择质量扣款明细"
      width="1200px"
      top="5vh">
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="amerces"
        @select="addDetail"
    >
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="登记日期">
            <el-date-picker
                v-model="createTime"
                :picker-options="pickerOptions"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="createTimeChange"/>
          </el-form-item>
          <el-form-item label="编号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入编号" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect";

  export default {
    name: "AmerceSelect",
    components: {TableSelect},
    data() {
      return {
        dialogVisible: false,
        filter: {
          billNo: "",
          beginCreateTime: "",
          endCreateTime: "",
        },
        createTime: "",
        pickerOptions: {
          shortcuts: [
            {
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              },
            },
          ],
        },
        selection: [],
        columns: [
          {title: "单号", key: "billNo", width: 200, align: "center"},
          {title: "创建时间", key: "creatorTime", width: 160, align: "center"},
          {title: "创建人", key: "creatorName", width: 140, align: "center"},
          {title: "供应商名称", key: "supplierName", align: "center"},
          {title: "供应商编码", key: "supplierCode", align: "center"},
          {title: "提交时间", key: "submitTime", width: 160, align: "center"},
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
            fixed: "left",
          },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },
      addDetail(row) {
        this.$http
          .get("basic", `amerces/${row.pkid}`)
          .then(resp => {
            this.dialogVisible = false;
            this.$emit("select", resp.data);
          });
      },
      createTimeChange(value) {
        if (value) {
          this.filter.beginCreateTime = value[0];
          this.filter.endCreateTime = value[1];
        } else {
          this.filter.beginCreateTime = "";
          this.filter.endCreateTime = "";
        }
      },
    },
  };
</script>
